import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSectionBatchMutation = createMutationHook(
  ShopRendererApiClient.createSectionBatch,
  {
    mutationKey: ['createSectionBatch'],
  },
)
